import Vue from 'vue'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_workbox_3374283c from 'nuxt_plugin_workbox_3374283c' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_nuxticons_0db8167c from 'nuxt_plugin_nuxticons_0db8167c' // Source: ./nuxt-icons.js (mode: 'all')
import nuxt_plugin_pluginrouting_65c2f280 from 'nuxt_plugin_pluginrouting_65c2f280' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_6515dcaf from 'nuxt_plugin_pluginmain_6515dcaf' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_markdownit_a8733d5a from 'nuxt_plugin_markdownit_a8733d5a' // Source: ./markdown-it.js (mode: 'all')
import nuxt_plugin_googleanalytics_2437bfc0 from 'nuxt_plugin_googleanalytics_2437bfc0' // Source: ./google-analytics.js (mode: 'client')
import nuxt_plugin_axios_525f1f74 from 'nuxt_plugin_axios_525f1f74' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_oni18nchange_1c852447 from 'nuxt_plugin_oni18nchange_1c852447' // Source: ../plugins/on-i18n-change (mode: 'all')
import nuxt_plugin_contentful_cbbecb4c from 'nuxt_plugin_contentful_cbbecb4c' // Source: ../plugins/contentful (mode: 'all')
import nuxt_plugin_s3_5d03b7d4 from 'nuxt_plugin_s3_5d03b7d4' // Source: ../plugins/s3 (mode: 'all')
import nuxt_plugin_veevalidate_6e5ad03a from 'nuxt_plugin_veevalidate_6e5ad03a' // Source: ../plugins/vee-validate (mode: 'all')
import nuxt_plugin_vlazyimg_2d31a552 from 'nuxt_plugin_vlazyimg_2d31a552' // Source: ../plugins/v-lazy-img (mode: 'all')
import nuxt_plugin_schediodesign_4be7f864 from 'nuxt_plugin_schediodesign_4be7f864' // Source: ../plugins/schedio-design (mode: 'all')
import nuxt_plugin_samebaseroutetransition_29033fc4 from 'nuxt_plugin_samebaseroutetransition_29033fc4' // Source: ../mixins/same-base-route-transition (mode: 'all')
import nuxt_plugin_vuescrolltoclient_6b7b8883 from 'nuxt_plugin_vuescrolltoclient_6b7b8883' // Source: ../plugins/vue-scrollto.client.js (mode: 'client')
import nuxt_plugin_vuexpersistedstateclient_5ccfc53e from 'nuxt_plugin_vuexpersistedstateclient_5ccfc53e' // Source: ../plugins/vuex-persistedstate.client.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp (ssrContext) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":(t) => {
      return t ? `${t} | Spartan Bioscience Inc.` : 'Spartan Bioscience Inc.'
    },"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Spartan support portal"},{"hid":"mobile-web-app-capable","name":"mobile-web-app-capable","content":"yes"},{"hid":"apple-mobile-web-app-title","name":"apple-mobile-web-app-title","content":"Spartan Support Portal"},{"hid":"author","name":"author","content":"Spartan Bioscience Inc."},{"hid":"theme-color","name":"theme-color","content":"#004c97"},{"hid":"og:type","name":"og:type","property":"og:type","content":"website"},{"hid":"og:title","name":"og:title","property":"og:title","content":"Spartan Support Portal"},{"hid":"og:site_name","name":"og:site_name","property":"og:site_name","content":"Spartan Support Portal"},{"hid":"og:description","name":"og:description","property":"og:description","content":"Spartan support portal"}],"script":[{"src":"https:\u002F\u002Fpolyfill.io\u002Fv3\u002Fpolyfill.min.js?features=document.currentScript,URL","crossorigin":"anonymous"}],"link":[{"rel":"preload","as":"style","href":"\u002Ffonts\u002FAvenirNext\u002Ffonts.min.css"},{"rel":"stylesheet","type":"text\u002Fcss","href":"\u002Ffonts\u002FAvenirNext\u002Ffonts.min.css"},{"rel":"manifest","href":"\u002F_nuxt\u002Fmanifest.e3769268.json"},{"rel":"shortcut icon","href":"\u002F_nuxt\u002Ficons\u002Ficon_64.1c3da8.png"},{"rel":"apple-touch-icon","href":"\u002F_nuxt\u002Ficons\u002Ficon_512.1c3da8.png","sizes":"512x512"}],"style":[],"htmlAttrs":{"lang":"en"}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  const inject = function (key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Plugin execution

  if (process.client && typeof nuxt_plugin_workbox_3374283c === 'function') {
    await nuxt_plugin_workbox_3374283c(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxticons_0db8167c === 'function') {
    await nuxt_plugin_nuxticons_0db8167c(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_65c2f280 === 'function') {
    await nuxt_plugin_pluginrouting_65c2f280(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_6515dcaf === 'function') {
    await nuxt_plugin_pluginmain_6515dcaf(app.context, inject)
  }

  if (typeof nuxt_plugin_markdownit_a8733d5a === 'function') {
    await nuxt_plugin_markdownit_a8733d5a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleanalytics_2437bfc0 === 'function') {
    await nuxt_plugin_googleanalytics_2437bfc0(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_525f1f74 === 'function') {
    await nuxt_plugin_axios_525f1f74(app.context, inject)
  }

  if (typeof nuxt_plugin_oni18nchange_1c852447 === 'function') {
    await nuxt_plugin_oni18nchange_1c852447(app.context, inject)
  }

  if (typeof nuxt_plugin_contentful_cbbecb4c === 'function') {
    await nuxt_plugin_contentful_cbbecb4c(app.context, inject)
  }

  if (typeof nuxt_plugin_s3_5d03b7d4 === 'function') {
    await nuxt_plugin_s3_5d03b7d4(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_6e5ad03a === 'function') {
    await nuxt_plugin_veevalidate_6e5ad03a(app.context, inject)
  }

  if (typeof nuxt_plugin_vlazyimg_2d31a552 === 'function') {
    await nuxt_plugin_vlazyimg_2d31a552(app.context, inject)
  }

  if (typeof nuxt_plugin_schediodesign_4be7f864 === 'function') {
    await nuxt_plugin_schediodesign_4be7f864(app.context, inject)
  }

  if (typeof nuxt_plugin_samebaseroutetransition_29033fc4 === 'function') {
    await nuxt_plugin_samebaseroutetransition_29033fc4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrolltoclient_6b7b8883 === 'function') {
    await nuxt_plugin_vuescrolltoclient_6b7b8883(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuexpersistedstateclient_5ccfc53e === 'function') {
    await nuxt_plugin_vuexpersistedstateclient_5ccfc53e(app.context, inject)
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
